import { Info } from "lucide-react";

export function OrderAutoNote() {
  return (
    <div className="rounded-lg bg-blue-50 border border-blue-100 p-3 flex items-start gap-3" data-testid="order-auto-note">
      <span className="h-8 w-8 rounded-md bg-blue-600 text-white flex items-center justify-center shrink-0">
        <Info className="h-4 w-4" />
      </span>
      <div className="text-sm">
        <p className="font-semibold text-blue-900">Handled automatically</p>
        <p className="text-blue-700 text-xs mt-0.5">The production line and completion estimate are assigned from the product's BOM. The order starts as <b>Pending</b>.</p>
      </div>
    </div>
  );
}
